//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  import { FilterPageViewModel } from "./FilterPageViewModel";

  export class JobWorkSpacePageViewModel extends ModelBase {
      static readonly $typeName = 'JobWorkSpacePageViewModel';
      public key: string;
      public errorPageView: FilterPageViewModel;
      public warningPageView: FilterPageViewModel;
      
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/JobWorkSpacePageViewModel.ts